// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterBar-cls1_Sa9","cls2":"FilterBar-cls2_ngk FilterBar-cls1_Sa9"};